import { default as Skeleton } from '@mui/material/Skeleton';

export const AssignmentChangeLogSkeleton = () => (
  <Skeleton
    data-testid="assignment-change-log-skeleton"
    height={160}
    sx={{ mt: 5 }}
  />
);
